import { render, staticRenderFns } from "./ViewBeneficiary.vue?vue&type=template&id=66922ddb"
import script from "./ViewBeneficiary.vue?vue&type=script&lang=js"
export * from "./ViewBeneficiary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports